import React, { useState, useEffect, useRef } from "react";
import { Modal } from "bootstrap";
import Swal from "sweetalert2";
import useApi from "../utils/useApi";
import { useLoading } from "../context/LoadingContext";

const CreateUserModal = ({ show, onClose, fetchUsers }) => {
  const { callApi } = useApi();
  const { setLoading } = useLoading();
  const modalRef = useRef(null);
  const bootstrapModalRef = useRef(null); // Persistent Bootstrap Modal instance

  const [formData, setFormData] = useState({
    user_name: "",
    user_email: "",
    user_password: "",
  });

  // ✅ Manage Bootstrap Modal Instance
  useEffect(() => {
    if (modalRef.current) {
      bootstrapModalRef.current = new Modal(modalRef.current, { keyboard: false });

      if (show) {
        bootstrapModalRef.current.show();
      }
    }
  }, [show]);

  // ✅ Cleanup Bootstrap Modal on unmount
  useEffect(() => {
    return () => {
      if (bootstrapModalRef.current) {
        bootstrapModalRef.current.hide();
        bootstrapModalRef.current.dispose();
      }
    };
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await callApi({
        endpoint: "/admin/generate-admin/store",
        method: "POST",
        data: formData,
      });

      Swal.fire("Success!", "User has been created successfully.", "success");
      fetchUsers();
      closeModal(); // ✅ Close modal properly
    } catch (error) {
      Swal.fire("Error", "Failed to create user. Try again later.", "error");
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    if (bootstrapModalRef.current) {
      bootstrapModalRef.current.hide(); // ✅ Hide Bootstrap Modal
    }
    onClose(); // ✅ Reset modal state in parent component
  };

  return (
    <div className="modal fade global_modal" ref={modalRef} id="createUserModal" tabIndex="-1">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Create User</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={closeModal}></button>
          </div>
          <div className="modal-body">
            <div className="global_modal_body">
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Username</label>
                  <input type="text" name="user_name" className="form-control" required onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input type="email" name="user_email" className="form-control" required onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label>Password</label>
                  <input type="password" name="user_password" className="form-control" required onChange={handleChange} />
                </div>
                <br />
                <div className="btn_holder">
                  <button type="submit" className="btn btn-primary">Submit</button>
                  <button type="button" className="btn btn-primary orange_btn" data-bs-dismiss="modal" onClick={closeModal}>Cancel</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateUserModal;
